import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';



export default function BotaoEngrenagem (props){
    return <Button 
                {...props}
                icon= "pi pi-cog"
                severity='primary'
                style={{padding :'4px'}}/>
}
    


 